import * as React from 'react';

const AccordionContext = React.createContext(undefined);
const AccordionItemContext = React.createContext(undefined);

export { AccordionContext, AccordionItemContext };
